import React from 'react';
const LoadingSkeleton = () => {
    return (React.createElement("div", { className: "mt-4 px-8 py-4 h-[80vh] flex justify-center" },
        React.createElement("div", { className: "animate-pulse space-y-4 w-full max-w-7xl" },
            React.createElement("div", { className: "flex space-x-3 mb-6 overflow-x-hidden" },
                React.createElement("div", { className: "h-8 bg-gray-200 rounded w-32" }),
                React.createElement("div", { className: "h-8 bg-gray-200 rounded w-24" }),
                React.createElement("div", { className: "h-8 bg-gray-200 rounded w-28" }),
                React.createElement("div", { className: "h-8 bg-gray-200 rounded w-36" }),
                React.createElement("div", { className: "h-8 bg-gray-200 rounded w-32" }),
                React.createElement("div", { className: "h-8 bg-gray-200 rounded w-30" }),
                React.createElement("div", { className: "h-8 bg-gray-200 rounded w-28" }),
                React.createElement("div", { className: "h-8 bg-gray-200 rounded w-26" }),
                React.createElement("div", { className: "h-8 bg-gray-200 rounded w-24" }),
                React.createElement("div", { className: "h-8 bg-gray-200 rounded w-32" }),
                React.createElement("div", { className: "h-8 bg-gray-200 rounded w-28" }),
                React.createElement("div", { className: "h-8 bg-gray-200 rounded w-30" })),
            [...Array(12)].map((_, i) => (React.createElement("div", { key: i, className: "flex space-x-3 py-3 overflow-x-hidden" },
                React.createElement("div", { className: "h-4 bg-gray-200 rounded w-32" }),
                React.createElement("div", { className: "h-4 bg-gray-200 rounded w-24" }),
                React.createElement("div", { className: "h-4 bg-gray-200 rounded w-28" }),
                React.createElement("div", { className: "h-4 bg-gray-200 rounded w-36" }),
                React.createElement("div", { className: "h-4 bg-gray-200 rounded w-32" }),
                React.createElement("div", { className: "h-4 bg-gray-200 rounded w-30" }),
                React.createElement("div", { className: "h-4 bg-gray-200 rounded w-28" }),
                React.createElement("div", { className: "h-4 bg-gray-200 rounded w-26" }),
                React.createElement("div", { className: "h-4 bg-gray-200 rounded w-24" }),
                React.createElement("div", { className: "h-4 bg-gray-200 rounded w-32" }),
                React.createElement("div", { className: "h-4 bg-gray-200 rounded w-28" }),
                React.createElement("div", { className: "h-4 bg-gray-200 rounded w-30" })))))));
};
export default LoadingSkeleton;
